import { getFirestore, doc, getDoc } from "firebase/firestore";
import { app } from "../config";

const db = getFirestore(app);

/**
 * Fetches the EO Business Profile from Firebase for a given user ID
 * @param {string} userId - The user's UID
 * @returns {Promise<{success: boolean, data?: object, error?: string}>}
 */
const getEOBusinessProfile = async (userId) => {
  try {
    if (!userId) {
      return { success: false, error: "User ID is required" };
    }

    const docRef = doc(db, "EO_BusinessProfiles", userId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return { success: true, data: docSnap.data() };
    } else {
      return { success: false, error: "Profile not found" };
    }
  } catch (error) {
    console.error("Error fetching EO Business Profile:", error);
    return { success: false, error: error.message };
  }
};

export { getEOBusinessProfile };
